export default {
	// SOLUTIONS
  'complex_solution': {
    heading: 'Complex solution',
    description: 'Thanks to its complexity Gracie can serve for gynecological examinations including colposcopy and small ambulatory operations as well as for ultrasound scan of patients.',
    images: [
			'gracie/FULL_HD_VIDEO_COLPOSCOPE.jpg'
		]
  },
  'tool_trolley': {
    heading: 'Tool trolley',
    description: "The instrument trolley is great complimentary product which saves space in the office and provides the doctor with maximum comfort during work.",
    images: [
			'gracie/TOOL_TROLLEY.jpg'
		]
  },

	// KEY FEATURES
  'easy_of_operation': {
    heading: 'Easy of operation',
    subExplanations: [
      'wireless_foot_controller',
      'hand_controller',
      'foot_controller'
    ]
  },
  'wireless_foot_controller': {
    heading: 'Wireless foot controller',
    description: 'Unique mobile wireless controller for the adjustment of the access, ultrasound and examination positions with a range of 10 meters.',
    images: [
      'gracie/FOOT_CONTROL_NEW.jpg'
    ],
    camera: {
      orbit: '2.5rad 1.1rad 270m',
      target: '-30m -20m -30m'
    }
  },
	'hand_controller': {
    heading: 'Hand controller',
    description: 'The possibility of saving positions in the memory (access, examination and ultrasound position) for three doctors – this makes 9 memory positions in total.',
    images: [
      'gracie/HAND_CONTROL_NEW.jpg'
    ],
    camera: {
      orbit: '1.7rad 1.05rad 240m',
      target: '-30m 50% -20m'
    }
  },
	'foot_controller': {
    heading: 'Foot controller',
    description: 'Is used to adjust the examination position according to the individual proportions of the patient.',
    images: [
      'gracie/WIRELESS_FOOT_CONTROLLER.jpg'
    ],
    camera: {
      orbit: '2.5rad 1.1rad 250m',
      target: '-30m -8m -30m'
    }
  },
	'positioning': {
    heading: 'Positioning',
    subExplanations: [
      'foot_rests',
      'synchronous_adjustment',
      'thigh_rests',
			'integrated_castors'
    ]
  },
	'foot_rests': {
    heading: 'Foot rests',
    description: 'Wide range of adjustment of the foot rests facilitates the doctor’s work and makes the patient’s stay on the chair more pleasant. According to the needs customers can choose between standard foot rests and Goepels.',
    images: [
      'gracie/Foot_rests.jpg',
			'gracie/Foot_rests_(Gopel_type).jpg'
    ],
    camera: {
      orbit: '-4rad 1.25rad 50%',
      target: '-80m 0 -10m'
    }
  },
	'synchronous_adjustment': {
    heading: 'Synchronous adjustment',
    description: 'Unique synchronous connection of the foot rests allows easy horizontal adjustment with just one hand.',
    images: [
      'gracie/SYNCHRONOUS_ADJUSTMENT.jpg'
    ],
    camera: {
      orbit: '-3rad 0.71rad 50%',
      target: '-40m 0 -40m'
    }
  },
	'thigh_rests': {
    heading: 'Thigh rests',
    description: 'Unique solution of thigh rests serve a a support for the patient’s legs when lying in the horizontal position.',
    images: [
      'gracie/THIGH_RESTS.jpg'
    ],
    camera: {
      orbit: '-4.7rad 1.45rad 50%',
      target: '-80m 0 -50m'
    }
  },
	'integrated_castors': {
    heading: 'Integrated castors',
    description: 'The gynecological chair GRACIE is equipped with a telescopic castor intended for moving the chair around the office. This original solution allows extremely easy handling of the chair.',
    images: [
      'gracie/INTEGRATED_CASTORS_2.jpg'
    ],
    camera: {
      orbit: 'initial',
      target: 'initial'
    }
  },
	'accesories': {
    heading: 'Accesories',
    subExplanations: [
      'full_hd_video_colposcope',
      'full_hd_lcd_screen',
      'instrument_bowl',
      'instrument_bowl2'
    ]
  },
  'full_hd_video_colposcope': {
    heading: 'Full HD video colposcope',
    description: 'Integration of a FULL HD video colposcope with polarizing filter into the chair reduces demands on space and increases examination efficiency at the same time. Wireless solution makes transfer of pictures and videos simple, comfortable and quick.',
    images: [
      'gracie/FULL_HD_VIDEO_COLPOSCOPE.jpg'
    ],
    camera: {
      orbit: '3.5rad 1.38rad 240m',
      target: '0 0 0'
    }
  },
	'full_hd_lcd_screen': {
    heading: 'Full HD LCD screen',
    description: 'The wide FULL HD screen makes the viewing of major details possible. The height and adjustment of the screen allows proper ergonomics during use. The possibility of attachment to either the left or right side of the chair.',
    images: [
      'gracie/FULL_HD_LCD_SCREEN.jpg'
    ],
    camera: {
      orbit: '2.5rad 1.4rad 240m',
      target: '-400% 150% 0'
    }
  },
	'instrument_bowl': {
    heading: 'Instrument bowl',
    description: 'Instrument bowl, large, stainless',
    images: [
      'gracie/PLASTIC_BOWL.jpg'
    ],
    camera: {
      orbit: '3.2rad 1.4rad 200m',
      target: '-80% 0 0'
    }
  },
	'instrument_bowl2': {
    heading: 'Instrument bowl',
    description: 'Instrument bowl, plastic',
    images: [
      'gracie/PLASTIC_BOWL.jpg'
    ],
    camera: {
      orbit: '3.2rad 1.4rad 200m',
      target: '-80% 0 0'
    }
  },
	'comfort': {
    heading: 'Comfort',
    subExplanations: [
      'heating_of_the_seat_part',
			'removable_foot_rests'
    ]
  },
  'heating_of_the_seat_part': {
    heading: 'Heating of the seat part',
    description: 'Heating of the seat part increases patient comfort.',
    images: [
      'gracie/HEATING.jpg'
    ],
    camera: {
      orbit: '-4.3rad 1.44rad 200m',
      target: '-450% 0 20%'
    }
  },
	'removable_foot_rests': {
    heading: 'Removable foot rests',
    description: 'The foot rests can be removed for easier handling of an immobile patient.',
    images: [
      'gracie/REMOVABLE_FOOTREST.jpg'
    ],
    camera: {
      orbit: '-4rad 1.56rad 300m',
      target: '-450% 0 20%'
    }
  }
}
